import { cancelOrderConstants } from '../constants';

const cancelOrder = (state, action) => {
    if (state === undefined) {
        return {
            data: {},
            loading: false,
            error: null,
            success: false,
        };
    }

    switch (action.type) {
        case cancelOrderConstants.FETCH_CANCEL_ORDER_REQUEST:
            return {
                data: action.payload,
                loading: true,
                error: null,
                success: false,
            };

        case cancelOrderConstants.FETCH_CANCEL_ORDER_SUCCESS:
            return {
                data: {},
                loading: false,
                error: null,
                success: true,
            };

        case cancelOrderConstants.FETCH_CANCEL_ORDER_FAILURE:
            return {
                data: action.payload,
                loading: false,
                error: true,
                success: false,
            };

        default:
            return state;
    }
};

export default cancelOrder;
